// Client mirror of buildJobReference (server/src/lib/jobReference.ts): the canonical
// {TYPE}-ELE-{number}-{DD}-{MM}-{YY} reference, for the engineer's phone, whose job payload carries
// the lift's ELE number and the scheduled instant but not the assembled reference. Same prefixes
// (a tech visit borrows REP), same London calendar day, same refusal to invent: null when it cannot
// be built. Bound to the server by a parity test (jobReference.parity.test.ts).
const PREFIX: Record<string, string> = { service: "SER", callout: "CO", repair: "REP", tech_visit: "REP", site_inspection: "INSP" };

function londonParts(d: Date): { dd: string; mm: string; yy: string } {
  const parts = new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/London", day: "2-digit", month: "2-digit", year: "numeric" }).formatToParts(d);
  const get = (t: string) => parts.find((p) => p.type === t)?.value ?? "";
  return { dd: get("day"), mm: get("month"), yy: get("year").slice(2) };
}

export function jobReferenceFor(job: { type: string; eleNumber: string | null | undefined; scheduledFor: string | null | undefined }): string | null {
  const prefix = Object.prototype.hasOwnProperty.call(PREFIX, job.type) ? PREFIX[job.type] : null;
  const ele = job.eleNumber?.trim();
  if (!prefix || !ele || !job.scheduledFor) return null;
  const d = new Date(job.scheduledFor);
  if (Number.isNaN(d.getTime())) return null;
  // A lift-less call-out already carries its own full reference as its "ele number".
  if (!/^ELE-\d/.test(ele)) return null;
  const { dd, mm, yy } = londonParts(d);
  return `${prefix}-${ele}-${dd}-${mm}-${yy}`;
}

// What a card prints as the reference: the canonical one, else the bare number, else a plain pending line.
export function jobReferenceLabel(job: { type: string; eleNumber: string | null | undefined; scheduledFor: string | null | undefined }): string {
  return jobReferenceFor(job) ?? job.eleNumber ?? "Reference pending";
}
